module.exports = __webpack_public_path__ + "static/media/banner-garante-full.7f52fee3.png";